import { render, staticRenderFns } from "./confirmAccept.vue?vue&type=template&id=6373a1b7&scoped=true"
import script from "./confirmAccept.vue?vue&type=script&lang=js"
export * from "./confirmAccept.vue?vue&type=script&lang=js"
import style0 from "./confirmAccept.vue?vue&type=style&index=0&id=6373a1b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373a1b7",
  null
  
)

export default component.exports